import React from 'react';
import PropTypes from 'prop-types';

import SidePanel from './SidePanel';

const SidePanelStickers = ({ onClose, children }) => (
  <SidePanel title="Add Sticker" showCloseButton onClose={onClose}>
    {children}
  </SidePanel>
);

SidePanelStickers.propTypes = {
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
};

SidePanelStickers.defaultProps = {
  children: null,
};

export default SidePanelStickers;
